angular.module('impactx.invoice').controller('InvoiceComplaintDialog', [
    'dataGen',
    'ConfirmationService',
    'TranslationService',
    'blhId',
    'viewPath',
    'savePath',
    '$scope',
    '$mdDialog',
    InvoiceComplaintDialog
]);

function InvoiceComplaintDialog(dataGen, ConfirmationService, TranslationService, blhId, viewPath, savePath, $scope, $mdDialog) {
    var self = this;

    self.saveLabel = TranslationService.get('save');
    self.abort = TranslationService.get('abort');

    dataGen.getData($scope, {id: blhId}, viewPath).then(function () {
    });

    self.checkRequireCtrlComplete = function (type) {
        return ($scope.data.completeComplaintDTOs[0] && $scope.data.completeComplaintDTOs[0].control[type.type] ? $scope.data.completeComplaintDTOs[0].control[type.type].showMust : false) || false;
    };

    self.checkRequireCtrlHeader = function (type) {
        return ($scope.data.headerComplaintDTOs[0] && $scope.data.headerComplaintDTOs[0].control[type.type] ? $scope.data.headerComplaintDTOs[0].control[type.type].showMust : false) || false;
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        dataGen.postAsForm({}, {matrix: $scope.data}, savePath).then(function () {
            $mdDialog.hide();
        });
    };

}